/**
 * RXJS
 */

import Config from '../../Config';
import Util from '../../Util';

class RXJS {

	constructor() {
	// 	const listAPIUrl =  Config.list( Config.board );
	// 	const allAPIUrl = Config.allList( Config.board );
	//
	// 	const listPromise: any = Util.get( listAPIUrl, 'GET');
	// 	const allPromise: any = Util.get( 'allAPIUrl', 'GET');
	// 	const list$ = Util.from( listPromise );
	// 	const all$ = Util.from( allPromise );
	//
	// 	const all = list$.pipe( Util.concat( all$ ) );
	//
	// 	list$.subscribe( ( val: any ) => console.log( val.articleList[ 0 ].articleId ) );
	// 	all$.subscribe( ( val: any ) => console.log( val.articleList[ 0 ].articleId ) );
	//
	// 	all.subscribe( ( val: any ) => console.log( val ), ( val: any ) => console.log( val ) );
	//
	// 	const source1 = Util.from([1,2,3,4,5]);
	// 	const subscribeTwo = source1.subscribe( ( val: any )=> console.log( `${val}`));
	//
	// 	const _pageList = [1, 2, 3, 4, 5 ];
	// 	const _cur = 3;
	// 	const _param = '&aaa=bbb';
	// 	const source2 = Util.of( ..._pageList )
	// 	  .pipe(
	// 	    Util.map( ( _v: any ) => ( _v === _cur ) ? `<li class="current">${_v}</li>` :`<li><a href="${Config.listPage}?page=${_v}${_param}" data-paging="${_v}">${_v}</a></li>` ),
	// 	    Util.scan( ( acc: string, curr: string ) => { return acc + curr })
	// 	  );
	//
	// 	source2.subscribe( ( pages: string ) => {
	// 	  console.log( pages );
	// 	}, () => {}, () => {})
	//
	}

}

export default RXJS;
